mutation CompanyBusinesUnitDelete($input: CompanyBusinesUnitDeleteInput!) {
  companyBusinesUnitDelete(input: $input) {
    deletedEntities {
      id
      rowTimestamp
    }
  }
}
